import Contract, {
  IPostContractPayload,
  IGetContractsPayload,
  IGetContractsByEmployeeIdPayload,
} from "app/models/contract"

export enum Types {
  POST = "CONTRACT_POST",
  POST_SUCCESS = "CONTRACT_POST_SUCCESS",
  POST_FAIL = "CONTRACT_POST_FAIL",
  GET = "CONTRACTS_GET",
  GET_SUCCESS = "CONTRACTS_GET_SUCCESS",
  GET_FAIL = "CONTRACTS_GET_FAIL",
  GET_BY_ID = "CONTRACTS_GET_BY_ID",
  GET_BY_ID_SUCCESS = "CONTRACTS_GET_BY_ID_SUCCESS",
  GET_BY_ID_FAIL = "CONTRACTS_GET_BY_ID_FAIL",
}

export type Action =
  | PostContractAction
  | PostontractSuccessAction
  | PostContractFailAction
  | GetContractsAction
  | GetContractsSuccessAction
  | GetContractsFailAction
  | GetContractsByIdAction
  | GetContractsByIdSuccessAction
  | GetContractsByIdFailAction

export type PostContractAction = {
  payload: IPostContractPayload
  type: Types.POST
}

export type PostontractSuccessAction = {
  type: Types.POST_SUCCESS
}

export type PostContractFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export type GetContractsAction = {
  payload: IGetContractsPayload
  type: Types.GET
}

export type GetContractsSuccessAction = {
  payload: { data: Contract[] }
  type: Types.GET_SUCCESS
}

export type GetContractsFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type GetContractsByIdAction = {
  type: Types.GET_BY_ID
  payload: IGetContractsByEmployeeIdPayload
}

export type GetContractsByIdSuccessAction = {
  type: Types.GET_BY_ID_SUCCESS
  payload: { data: Contract[] | undefined }
}

export type GetContractsByIdFailAction = {
  type: Types.GET_BY_ID_FAIL
  payload: { errors: object }
}

export function postContract(payload: IPostContractPayload): PostContractAction {
  return {
    payload,
    type: Types.POST,
  }
}

export function postContractSuccess(): PostontractSuccessAction {
  return {
    type: Types.POST_SUCCESS,
  }
}

export function postContractFail(errors: object): PostContractFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}

export function getContracts(payload: IGetContractsPayload): GetContractsAction {
  return {
    payload,
    type: Types.GET,
  }
}

export function getContractsSuccess(data: Contract[]): GetContractsSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getContractsFail(errors: object): GetContractsFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function getContractsById(payload: IGetContractsByEmployeeIdPayload): GetContractsByIdAction {
  return {
    payload,
    type: Types.GET_BY_ID,
  }
}

export function getContractsByIdSuccess(data: Contract[] | undefined): GetContractsByIdSuccessAction {
  return {
    payload: { data },
    type: Types.GET_BY_ID_SUCCESS,
  }
}

export function getContractsByIdFail(errors: object): GetContractsByIdFailAction {
  return {
    payload: { errors },
    type: Types.GET_BY_ID_FAIL,
  }
}
